import {observer} from "mobx-react";
import * as React from "react";
import {action, observable} from "mobx";
import {CommentDataInterface} from "../../../data/FullPostModalData";

import {NavAvatar} from "../../nav/NavAvatar";

import './CommentAdd.pcss';
import {resizeImage} from "../../../utils";
import {User} from "../../../data/entities/User";
import {Alert} from "../../../data/Alert";

interface Props {
  addComment:(commentData:CommentDataInterface)=>Promise<void>;
  user:User;
}

const IMAGE_DISPLAY_WIDTH = 654;

@observer
export class CommentAdd extends React.Component<Props> {
  @observable active = false;
  @observable submittingComment = false;
  @observable resizingImage = false;
  @observable comment = "";
  @observable imageDataURI:any;
  imageInputRef;
  textareaRef;



  constructor(props:Props) {
    super(props);

    this.imageInputRef = React.createRef();
    this.textareaRef = React.createRef();
  }

  @action handleSubmitComment = () => {

    if(this.submittingComment) {
      return;
    }

    this.submittingComment = true;
    if(this.comment.trim().length<2) {
      Alert.alert('Text is required to post a comment.');
      this.submittingComment = false;
      return;
    }

    const commentData = {
      comment:this.comment.trim(),
      photo:this.imageDataURI?this.imageDataURI:undefined,
    }

    this.props.addComment(commentData)
    .then(action(() => {
      this.submittingComment = false;
      this.handleCancel();
    }))
    .catch(action((err) => {
      console.log(err);
      Alert.alert('We\'re sorry! It looks like you might not be connected to the Internet. Please make sure you have a good Internet connection and try to post again. If that does not work, please log in again.');
      this.submittingComment = false;
    }));

  }

  renderPreview = (input) => {
    if(this.imageInputRef.current) {
      this.active = true;
      if (this.imageInputRef.current.files && this.imageInputRef.current.files[0]) {
        if(!this.resizingImage) {
          this.resizingImage = true;
          resizeImage(this.imageInputRef.current.files[0], IMAGE_DISPLAY_WIDTH)
              .then((image) => {
                this.imageDataURI = image;
                this.resizingImage = false;
              })
              .catch((err) => {
                console.log(err);
                this.resizingImage = false;
                Alert.alert('The image you selected did not work. Please try again.');
              });
        }
      }
    }
  }

  @action handleCancel = () => {
    this.comment = '';
    this.imageDataURI = null;
    this.active = false;
    this.textareaRef.current.innerHTML = '';
  }

  handleImageIconClick = () => {
    if(!this.submittingComment) {
      this.imageInputRef.current.click();
    }
  }

  @action handleClearImage = () => {
    this.imageDataURI = null;
    this.imageInputRef.current.value = null;
  }

  render(){
    return (
        <div className="add-comment">

          <h3 className="ac-label">Add a comment</h3>
          <div className={`ac-content${this.active?' active':''}`}>
            {!this.active ?
                <div className={`ac-content-top`}>
                  <NavAvatar  user={this.props.user} variant={'small'} />
                </div>
            :
                <div className={"ac-content-top"}>
                  <NavAvatar user={this.props.user} variant={'small'} />
                  <div className={"ac-username"}>{this.props.user.nameOrNickname}</div>
                  <div className={"ac-actions"}>
                    <a className="ac-btn cancel" onClick={this.handleCancel}>Cancel</a>
                    <a className="ac-btn post" onClick={this.handleSubmitComment}>Post</a>
                  </div>
                </div>
            }
            <span
              ref={this.textareaRef}
              className={`ac-textarea${this.imageDataURI?'':' no-image'}`}
              role="textbox"
              contentEditable
              onInput={action((event)=>{
                this.comment = event.currentTarget.textContent?event.currentTarget.textContent:'';
              })}
              onFocus={()=>{
                this.active = true;
                if(!this.imageDataURI) {
                  setTimeout(() => {
                    const elements = document.getElementsByClassName("body scroll");
                    if (elements.length > 0) {
                      elements[0].scrollTo({left: 0, top: elements[0].scrollHeight, behavior: "smooth"});
                    }
                  }, 1);
                }
              }}
            ></span>
            <input ref={this.imageInputRef} type="file" id="fileUpload" style={{opacity:0, height:0, width:0, position:'absolute'}} onChange={this.renderPreview} />

            {!this.imageDataURI ?
                <>
                {this.resizingImage ?
                    <span className="material-icons icon-spin resizing">sync</span>
                    :
                    <a className={"ac-image-btn"} href={"#"} onClick={this.handleImageIconClick}><span className="material-icons">photo_library</span></a>
                }
                </>

                :
                <div className={"ac-image"}>
                  <img alt={"Preview"} src={this.imageDataURI} />
                  <a className={"ac-image-btn-clear"} href={"#"} onClick={this.handleClearImage}><span className="material-icons">close</span></a>
                </div>
            }
          </div>
        </div>
    );
  }

}
